import { createSvgIcon } from '../../createSvgIcon';

const strokeProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2
};

export const BuildingIcon = createSvgIcon(
  <>
    <path
      d="M10.5999 1H5.79985C3.15185 1 2.59985 1.552 2.59985 4.2V17H13.7999V4.2C13.7999 1.552 13.2479 1 10.5999 1Z"
      strokeLinejoin="round"
      {...strokeProps}
    />
    <path
      d="M1 17H15.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...strokeProps}
    />
    <path
      d="M10.6 17V14.6C10.6 13.276 10.324 13 9.00005 13H7.40005C6.07605 13 5.80005 13.276 5.80005 14.6V17"
      strokeLinejoin="round"
      {...strokeProps}
    />
    <path
      d="M9.4 4.19995H7M9.4 6.99995H7M9.4 9.79995H7"
      strokeLinecap="round"
      {...strokeProps}
    />
  </>,
  { displayName: 'BuildingIcon', viewBox: '0 0 17 18' }
);
